import { useTranslation } from 'react-i18next';
import { useMyOfferListings } from '@steelbuy/data-access';

import { EmptyState, Notification, NotificationLevel } from '@steelbuy/ui-primitive';

import { MyOfferList } from './MyOfferList';
import { useMyOffersContext } from './MyOffersContext';
import { TableLayout } from '../../views/layouts/table-layout/TableLayout';
import { GenericError } from '../generic-error/GenericError';
import { PageHeader } from '../page-header/PageHeader';

import './MyOffers.scss';

export const MyOffers = () => {
    const { filter } = useMyOffersContext();
    const { t } = useTranslation(['translation', 'uiDomain']);
    const { data, hasNextPage, total, fetchNextPage, isFetchingNextPage, isLoading, error } = useMyOfferListings({
        filter,
    });

    return (
        <div className="my-offers">
            <PageHeader pageTitle={t('application.myOffers.pageHeader')} />
            {error ? (
                <GenericError />
            ) : (
                <TableLayout>
                    <Notification level={NotificationLevel.INFO} message={t('application.myOffers.infoMsg')} stayOpen />
                    <MyOfferList
                        results={data || []}
                        totalResults={total}
                        handleLoadMore={fetchNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        hasNext={hasNextPage}
                        isLoading={isLoading}
                    />
                    {!isLoading && !data?.length && (
                        <div className="my-offers__empty">
                            <EmptyState
                                caption={t('uiDomain:commonList.noListCaption')}
                                imgSrc="/assets/lib-ui-primitive/images/EmptyStateResult.svg"
                                description={t('application.myOffers.noResultsText')}
                            />
                        </div>
                    )}
                </TableLayout>
            )}
        </div>
    );
};
